import { useGetCurrentPublishedTool } from "../../hooks/useTools";
import { OldVersionMessageBar } from "../OldVersionMessageBar";

interface OldToolVersionMessageBarProps {
  toolId: string;
}

export const OldToolVersionMessageBar = (
  props: OldToolVersionMessageBarProps
) => {
  const { toolId } = props;

  const {
    data: currentVersion,
    isLoading: isCurrentLoading,
    isRefetching: isCurrentRefetching,
  } = useGetCurrentPublishedTool(toolId);

  return (
    <OldVersionMessageBar
      type="tool"
      currentVersion={{
        versionId: currentVersion?.versionId ?? "",
        title: currentVersion?.title ?? "",
      }}
      isLoading={isCurrentLoading}
      isRefetching={isCurrentRefetching}
    />
  );
};
